/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { getOverflowAncestors } from '@floating-ui/react-dom';

const defaultTarget = typeof window !== 'undefined' ? window : null;

export default function useScrollTrigger(options = {}) {
  const {
    anchorEl,
    monitor = false,
    target = defaultTarget
  } = options;
  const [trigger, setTrigger] = React.useState(false);

  useEffect(() => {
    if (!monitor) {
      setTrigger(false);
      return;
    }

    const anchor = typeof anchorEl === 'function' ? anchorEl() : anchorEl;
    const targets = anchor
      ? getOverflowAncestors(anchor).filter((el) => el !== window.visualViewport)
      : [target];

    const handleScroll = () => setTrigger(true);

    targets.forEach((el) => el.addEventListener('scroll', handleScroll, { passive: true }));
    return () => targets.forEach((el) => el.removeEventListener('scroll', handleScroll));
  }, [anchorEl, target, monitor]);

  return { trigger };
}
